// extracted by mini-css-extract-plugin
export default {"exportPdfButton":"dcc_comparisonPdfButton-exportPdfButton","pdfIcon":"dcc_comparisonPdfButton-pdfIcon"};